import Menu from "./menu";
import Copyright from "./copyright";

const Footer = () => {
  return (
    <footer className="band-hero pt-4">
      <Menu />
      <Copyright />
    </footer>
  );
};

export default Footer;
